import { HubbingIcon } from './icons'
import { canViewRegistryLink, companyZefixUrl, registryLinkEnabled } from './companyZefixLink'
import './RegistryLink.css'

const COPY = {
  fr: { label: 'Consulter sur Zefix', newTab: 'nouvel onglet' },
  de: { label: 'In Zefix nachsehen', newTab: 'neuer Tab' },
  it: { label: 'Consulta su Zefix', newTab: 'nuova scheda' },
  en: { label: 'View on Zefix', newTab: 'new tab' },
}

export default function RegistryLink({ company, plan, authenticated = false, lang = 'fr', requirePaidPlan = true, label, className = '', style }) {
  if (!authenticated || !registryLinkEnabled() || (requirePaidPlan && !canViewRegistryLink(plan))) return null
  const href = companyZefixUrl(company, lang)
  if (!href) return null
  const copy = COPY[lang] || COPY.fr
  const text = label || copy.label
  const stopCardGesture = event => event.stopPropagation()
  return <a className={`hb-company-registry-link ${className}`.trim()} style={style} href={href}
    target="_blank" rel="noopener noreferrer"
    aria-label={`${text}${company?.name ? ` — ${company.name}` : ''} (${copy.newTab})`}
    onClick={stopCardGesture} onPointerDown={stopCardGesture} onTouchStart={stopCardGesture}>
    <HubbingIcon name="building" size={14} color="currentColor" />
    <span>{text}</span>
  </a>
}
